import { authApiService } from '@/api/authApiService';
import { ApiParams } from '@/api/helpers/apiHelpers';
import { ApiResponseType, ListResponseType } from '@/types/sharedTypes';
import { VaultAccountType, VaultRegionType } from '@/types/myVaultTypes';

export type VaultAccountsListType = ListResponseType<VaultAccountType>;
export type VaultRegionsType = { regions: VaultRegionType[] };

export const getVaultAccountsApi = (params?: ApiParams): Promise<ApiResponseType<VaultAccountsListType>> => {
  return authApiService.GET('/my-vault/accounts/', params);
};

export const getVaultRegionsApi = (): Promise<ApiResponseType<VaultRegionsType>> => {
  return authApiService.GET('/my-vault/accounts/', { regions_only: '1' });
};
